import { SERVICE } from '@src/api/types/shared/serviceType';
import CommonHelmet from '@src/components/CommonHelmet';
import CompanyGuard from '@src/components/guard/CompanyGuard';
import ArticleShow from '@src/features/company/articles/ArticleShow';
import CompanyDefaultLayout from '@src/layouts/company/CompanyDefaultLayout';
import { useState } from 'react';

function CompanyArticleDetail() {
  const [feature, setFeature] = useState('');
  const [description, setDescription] = useState('');

  return (
    <CompanyGuard canService={[SERVICE.ENTERPRISE_PORTAL]}>
      <CompanyDefaultLayout pageName='articles'>
        <CommonHelmet
          feature={feature}
          description={description}
        />
        <ArticleShow
          setFeature={setFeature}
          setDescription={setDescription}
        />
      </CompanyDefaultLayout>
    </CompanyGuard>
  );
}

export default CompanyArticleDetail;
